import axios from 'axios';
import * as apiURL from './apiConfig';
import qs from 'qs';

export const getHeroSliders = async () => {
  try {
    const response = await axios.get(apiURL.HERO_SLIDERS);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getFrontMenus = async () => {
  try {
    const response = await axios.get(apiURL.FRONT_MENUS);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getParentCategories = async () => {
  try {
    const response = await axios.get(apiURL.PARENT_CATEGORIES);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getBrands = async () => {
  try {
    const response = await axios.get(apiURL.BRAND_URL);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getHighlights = async () => {
  try {
    const response = await axios.get(apiURL.HIGHLIGHT_URL);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getMostPopularItems = async () => {
  try {
    const response = await axios.get(apiURL.MOST_POPULAR_URL);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getCategoryTree = async () => {
  try {
    const response = await axios.get(apiURL.CATEGORY_TREE);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getCategoryFilters = async (params) => {
  try {
    const response = await axios.get(apiURL.CATEGORY_FILTERS, {
      params: params,
      paramsSerializer: (data) => {
        return qs.stringify(data, {
          arrayFormat: 'repeat',
          plainObjects: true,
        });
      },
    });
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getSearchSuggestions = async (value) => {
  try {
    const response = await axios.get(
      `${apiURL.SEARCH_SUGGESTION}?term=${value || ''}`
    );
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getDealsOfTheDay = async () => {
  try {
    const response = await axios.get(`${apiURL.DAILY_DEALS_URL}`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getCouponDetails = async () => {
  try {
    const response = await axios.get(`${apiURL.COUPONS_URL}`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
